import React, { useCallback, useState } from 'react';

import Loader from '../components/layout/loader/Loader';
import NotFoundPage from '../components/reusable/error-pages/NotFoundPage/NotFoundPage';

const LayoutContext = React.createContext();

export function LayoutProvider(props) {
  const [loaderIds, setLoaderIds] = useState([]);
  const [isNotFoundPage, setIsNotFoundPage] = useState(false);

  const showNotFoundPage = useCallback(() => {
    setIsNotFoundPage((prevValue) => (prevValue ? prevValue : true));
  }, []);

  const hideNotFoundPage = useCallback(() => {
    setIsNotFoundPage((prevValue) => (prevValue ? false : prevValue));
  }, []);

  const showLoader = useCallback((customId) => {
    const id = customId || Math.floor(Math.random() * 1000000000);
    setLoaderIds((prevValue) => [...prevValue, id]);

    return id;
  }, []);

  const hideLoader = useCallback((id) => {
    setLoaderIds((prevValue) =>
      prevValue?.filter((loaderId) => loaderId !== id),
    );
  }, []);

  return (
    <LayoutContext.Provider
      value={{
        showNotFoundPage,
        hideNotFoundPage,
        showLoader,
        hideLoader,
      }}>
      {!!loaderIds.length && <Loader />}
      {!!isNotFoundPage && <NotFoundPage />}
      {!isNotFoundPage && props.children}
    </LayoutContext.Provider>
  );
}

function useLayout() {
  const context = React.useContext(LayoutContext);
  if (context === undefined) {
    throw new Error('useLayout must be used within an LayoutContext');
  }

  return context;
}

export { useLayout, LayoutContext };
